export default {
  en: 'english',
  'zh-cn': '简体中文',
  'zh-hk': '繁體中文',
}
